import { render, staticRenderFns } from "./BlockVehicle.vue?vue&type=template&id=478c4de4&"
import script from "./BlockVehicle.vue?vue&type=script&lang=js&"
export * from "./BlockVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports